module.exports = __webpack_public_path__ + "media/components/util/logos/vecteezy-opengraph-5815e2ab4993dcde975b587110612698.jpg";